import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  TableHead,
  TableRow,
  TableCell,
  Button,
  TableContainer,
  Table,
  TableBody,
  Box,
  Grid,
  Checkbox,
  Link,
} from '@material-ui/core';
import { green, yellow } from '@material-ui/core/colors';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Web3Service from '../../services/Web3Service.jsx';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: '0 5px',
    },
  },
  iconReady: {
    color: green[500],
  },
  iconBusy: {
    color: yellow[500],
  },
}));

export default function TowersTable(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selected, setSelected] = React.useState(null);

  const handleClick = (event, id) => {
    setSelected(id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleVerify = () => {
    setAnchorEl(null);
    if (selected !== null) {
      props.handleOpen(selected);
    }
  };

  const towers = props.data;

  return (
    <React.Fragment>
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={props.numSelected > 0 && props.numSelected < props.rowCount}
              checked={props.rowCount > 0 && props.numSelected === props.rowCount}
              onChange={props.onSelectAllClick}
              disabled={(towers.length === 0)}
              inputProps={{ 'aria-label': 'select all towers' }}
            />
          </TableCell>
          <TableCell align="right">id</TableCell>
          <TableCell align="right">Name</TableCell>
          <TableCell align="right">Bank</TableCell>
          <TableCell align="right">Height</TableCell>
          <TableCell align="right">Rate</TableCell>
          <TableCell align="right">State</TableCell>
          <TableCell align="right">Private</TableCell>
          <TableCell align="right">Founder</TableCell>
          <TableCell align="right"></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {
        (towers.length !== 0)
          ? props.data.map((tower, index) => {
            //
            const isItemSelected = props.isSelected(tower.id);
            //
            const url = (process.env.INFURA_NETWORK === 'ropsten') ? 'ropsten.etherscan.io' : 'etherscan.io';
            //
            return (
            <TableRow
              key={index}
              hover
              role="checkbox"
              aria-checked={isItemSelected}
              selected={isItemSelected}
            >
              <TableCell padding="checkbox">
                <Checkbox
                  checked={isItemSelected}
                  // inputProps={{ 'aria-labelledby': labelId }}
                  onChange={(event) => props.handleRowClick(event, tower.id)}
                />
              </TableCell>
              <TableCell align="right">{tower.ethId}</TableCell>
              <TableCell align="right">Tower-{tower.ethId}</TableCell>
              <TableCell align="right">{Web3Service.convert(tower.bank)}</TableCell>
              <TableCell align="right">{tower.height}</TableCell>
              <TableCell align="right">{Web3Service.convert(tower.rate)}</TableCell>
              <TableCell align="right">
                {(tower.state)
                  ? <CheckCircleIcon className={classes.iconReady}/>
                  : <HourglassEmptyIcon className={classes.iconBusy}/>}
              </TableCell>
              <TableCell align="right">
                {(tower.isPrivate) ? <LockIcon /> : <LockOpenIcon/>}
              </TableCell>
              <TableCell align="right">
                <Link color="primary" href={`https://${url}/address/${tower.founder}`} target="_blank">
                  {`${tower.founder.slice(0, 6)}...${tower.founder.slice(38)}`}
                </Link>
              </TableCell>
              <TableCell align="right">
                <IconButton aria-controls="tower-actions" aria-haspopup="true" onClick={(event) => handleClick(event, tower.ethId)}>
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>);
          })
          : <TableRow style={{ height: 81 * props.emptyRows }}>
              <TableCell align="center" colSpan={10}>
                {'Data not loaded'}
              </TableCell>
            </TableRow>
          }
          {
            ((props.emptyRows > 0) && (towers.length < props.rowsPerPage) && (towers.length !== 0)) && (
              <TableRow style={{ height: 81 * props.emptyRows }}>
                <TableCell colSpan={10} />
              </TableRow>
            )
          }
      </TableBody>
      <Menu
        id="tower-actions"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View" />
        </MenuItem>
        <MenuItem onClick={handleVerify}>
          <ListItemIcon>
            <VerifiedUserIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Verify" />
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

TowersTable.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpen: PropTypes.func.isRequired,
  handleRowClick: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  numSelected: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
  isSelected: PropTypes.func.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  emptyRows: PropTypes.number.isRequired,
};
